// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! * [Scalable Text in CSS with Maximum and Minimum Sizes](https://github.com/kevinmack18/SCALABLE-TEXT-IN-CSS) */.sick-signs__label{width:14.2857142857%}@media only screen and (min-width:768px){.sick-signs__label{width:8.3333333333%}}.sick-signs__other{border:1px solid #000;height:25px;margin-left:4rem;padding:0 .5rem;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
